import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Typography, Snackbar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import '../../../css/core/components/AnnouncementSnackbar.scss';

class AnnouncementSnackbar extends Component {
  state = {
    open: this.props.openMessageSnackbar,
  };

  handleClose = () => {
    const { actions } = this.props;
    this.setState({ open: false });
    actions.clearMessage();
  }

  isMessageEmpty = () => {
    const { message } = this.props;
    if (message.title === '' && message.message === '') return true;
    return false;
  }

  render() {
    const { message } = this.props;

    // TO-DO: remove inline styles
    const rootClasses = {
      'background-color': '#edc9c9',
      color: 'red',
      width: '100%',
      'flex-wrap': 'nowrap',
    };

    return (
      !this.isMessageEmpty()
      && (
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.open}
          ContentProps={{
            'aria-describedby': 'message-id',
            style: { root: rootClasses },
          }}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              className="announcementSnackbar-iconButton"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
          message={
            <div id="message-id" className="announcementSnackbar-messageContainer">
              <Icon className="announcementSnackbar-warningIcon">info_icon</Icon>
              <Typography className="announcementSnackbar-messageText">
                {`${message.title} ${message.message}`}
              </Typography>
            </div>
          }
        />
      )
    );
  }
}

AnnouncementSnackbar.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  openMessageSnackbar: PropTypes.bool.isRequired,
  message: PropTypes.objectOf(PropTypes.any),
};

AnnouncementSnackbar.defaultProps = {
  message: {},
};

export default AnnouncementSnackbar;
